import AttributeLookupPagingResultModelBase from '../_generated/modelBases/attribute-lookup-paging-result-model-base';

export default class AttributeLookupPagingResultModel extends AttributeLookupPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
